import { Stack } from '@mui/material';

import { BlockValueTemplateFieldArea } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function DocumentSearchFormFields() {
  return (
    <Stack spacing={2}>
      <BlockValueTemplateFieldArea
        fieldName="config.searchQuery"
        label="Search Query"
        helperText="Query to search documents with. To pull upstream data into the query, use {{upstreamBlockName.data}}."
        required
      />
    </Stack>
  );
}
